const { ListItem } = require('@andes/list');

module.exports = ListItem;
